import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../layouts/MainLayout";
import Spinner from "../components/DNVSpinner";
import { ApplicationState } from "../store";
import { UserDto } from "../autogenerated/models";
import Table from "../components/Table";
import { ColumnsType } from "antd/es/table";
import { Button } from "antd";

import { getSubscribersWithSessions } from "../store/slices/testSessionsSlice";
import UserSessionTable from "../containers/admin/UserSessionTable";

const UserSessionsPage = () => {
  const { isLoading, users, usersPage } = useSelector(
    (state: ApplicationState) => {
      return state.testSessions;
    }
  );

  const currentUser = useSelector(
    (state: ApplicationState) => state.init.data.user
  );

  const dispatch = useDispatch();

  const fetchInitial = useCallback(
    () => dispatch(getSubscribersWithSessions(0)),
    [dispatch]
  );

  useEffect(() => {
    fetchInitial();
  }, [fetchInitial]);

  const pageChangeHandler = (page: number) => {
    dispatch(getSubscribersWithSessions(page));
  };

  const expandedRowRender = (record: UserDto) => {
    return <UserSessionTable user={record} currentUser={currentUser ?? {}} />;
  };

  const columns: ColumnsType<UserDto> = [
    {
      title: "User",
      dataIndex: "name",
      key: "name",
    },
  ];

  return (
    <div className="cimbion-homepage">
      <MainLayout>
        {isLoading ? (
          <Spinner />
        ) : (
          <div className="container">
            <Table
              rowKey={(record) => record.id ?? ""}
              columns={columns}
              dataSource={users}
              pagination={false}
              expandable={{
                expandedRowRender,
                expandRowByClick: true,
                defaultExpandAllRows: false,
              }}
            />
            <div className="pagination">
              <Button
                size="middle"
                disabled={usersPage === 0}
                onClick={() => pageChangeHandler(usersPage - 1)}
              >
                <i className="fas fa-chevron-left"></i>
              </Button>
              <span className="pageNumber">{usersPage}</span>
              <Button
                size="middle"
                disabled={users?.length !== 50}
                onClick={() => pageChangeHandler(usersPage + 1)}
              >
                <i className="fas fa-chevron-right"></i>
              </Button>
            </div>
          </div>
        )}
      </MainLayout>
    </div>
  );
};

export default UserSessionsPage;
